import './_pagination-buttons.scss';

export function addPaginationButtons(config) {
    const pageSection = document.querySelector(config.pageSection);
    if(!pageSection) return;
    const paginationContainer = pageSection.querySelector(config.paginationContainer);
    const scrollSection = pageSection.querySelector(config.scrollSection);

    if(!paginationContainer || !scrollSection || scrollSection.offsetWidth === 0) return;

    paginationContainer.innerHTML = '';
    const numberOfButtons = Math.ceil( scrollSection.scrollWidth / scrollSection.offsetWidth);
    const pageSectionWidth = pageSection.offsetWidth;

    if((scrollSection.scrollWidth - config.scrollSectionPadding) <= pageSectionWidth) return;

    const buttons = Array.from({ length: numberOfButtons }, (_, i) => createButton(i, scrollSection, config));
    buttons.forEach(button => paginationContainer.appendChild(button));

    scrollSection.addEventListener('scroll', () => {
        const index = Math.round((scrollSection.scrollLeft / scrollSection.scrollWidth) * (buttons.length));
        const isScrolledToRight = scrollSection.scrollLeft + scrollSection.offsetWidth >= scrollSection.scrollWidth;
        buttons.forEach((indicator, i) => {
            const isActive = isScrolledToRight ? !!(i === buttons.length - 1) : !!(i === index);
            indicator.setAttribute('aria-pressed', isActive.toString());
        });
    });
}

function createButton(index, scrollSection, config) {
    const button = document.createElement('button');
    button.classList.add('pagination-button');
    const circle = document.createElement('span');
    circle.classList.add('pagination-circle');
    button.appendChild(circle);
    button.setAttribute('aria-label', `Scroll to item #${index + 1}`);
    if (index === 0) {
        button.setAttribute('aria-pressed', 'true');
    }

    button.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const totalItems = scrollSection.querySelectorAll(config.productCard).length;
        const numberOfButtons = Math.ceil( scrollSection.scrollWidth / scrollSection.offsetWidth);
        const itemsPerButton = totalItems / numberOfButtons;
        const productCardWidth = scrollSection.querySelector(config.productCard).offsetWidth;
        const itemWidthPerButton = itemsPerButton * (productCardWidth + 16);
        const scrollLeft = itemWidthPerButton * index;
        scrollSection.scrollTo({
            left: scrollLeft,
            behavior: 'smooth'
        });
    });
    return button;
}
